import cookie from '../plugins/jquery.cookie.js';
import Headroom from '../plugins/headroom.js';
import Slick from '../plugins/slick.js';

jQuery(function($) {

  // Project Slider
  var $imageSlider = $('.project-slider');
  var $infoSlider  = $('.project-info-slider');

  $imageSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    draggable: false,
    swipe: false,
    asNavFor: '.project-info-slider'
  });

  $infoSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.arrow-prev'),
    nextArrow: $('.arrow-next'),
    fade: true,
    draggable: false,
    swipe: false,
    asNavFor: '.project-slider'
  });

  // Sticky Header
  var myElement = document.querySelector(".global-header");
  var headroom  = new Headroom(myElement, {
    "offset": 150,
    "tolerance": 0
  });
  headroom.init();

  // Search
  (function () {
    var input = document.getElementById('search-input');
    var btn = document.getElementById('search-btn');
    var BREAKPOINT = 768; // adjust if needed

    function update() {
      if (window.innerWidth < BREAKPOINT) {
        input.placeholder = 'Keyword…';
        btn.textContent = 'Go';
      } else {
        input.placeholder = 'Enter keyword…';
        btn.textContent = 'Search';
      }
    }

    update();
    window.addEventListener('resize', update);
  })();
  $('.search-toggle').click(function(e){
    e.preventDefault();
    $('#search-popup').toggleClass('active');
    $('#search-input').focus();
  });
  $('.close-search').click(function(){
    $('#search-popup').removeClass('active');
  });

  // Pagination
  $('#pagination').on('click', 'a', function(e){
    e.preventDefault();
    $(this).remove();
    $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
      $('#ajax-posts').append($('#ajax-loader').html());
    });
    $('#pagination').load($(this).attr('href') + ' #pagination>*');
  });

  // Anchor
  $('a').on('click', function(e){
    var $href = $(this).attr('href');
    if ($href.match('^#mailinglist')) {
      e.preventDefault();
      $('#mailinglist').addClass('visible');
    } else if ($href.match('^#') && !$(this).hasClass('accordion-tab')) {
      e.preventDefault();
      $('html, body').stop().animate({
          scrollTop: $($href).offset().top
      });
    }
  });

  // Video popups
  $('a').on('click', function(e){
    if (!$(this).parent('li').hasClass('youtube') && !$(this).parent('li').hasClass('vimeo')) {
      var $target = $(this).attr('href');
      if ($target.toLowerCase().indexOf("vimeo") >= 0) {
        e.preventDefault();
        var $n = $target.lastIndexOf('/');
        var $vid = $target.substring($n + 1);
        $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        $('.video-popup-wrapper').addClass('active');
        $('body, html').addClass('body-noscroll');
      }
      if ($target.toLowerCase().indexOf("youtu") >= 0) {
        e.preventDefault();
        var $y = $target.lastIndexOf('=');
        var $yid = $target.substring($y + 1);
        $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        $('.video-popup-wrapper').addClass('active');
        $('body, html').addClass('body-noscroll');
      }
    }
  });
  $('.close-popup').on('click', function(){
    $('#mailinglist').removeClass('visible');
    $('.video-popup-wrapper').removeClass('active');
    $('.popup-content').html('');
    $('body, html').removeClass('body-noscroll');
  });

  // Mobile Nav
  var $scrollposition = 0;
  $('#mobile-nav-toggle').on('click', function(){
    if ($(this).hasClass('active')) {
      $('body, html').removeClass('nav-locked');
      $(window).scrollTop($scrollposition);
    } else {
      $scrollposition = $(window).scrollTop();
      $('body, html').addClass('nav-locked');
      $(window).scrollTop(0);
    }
    $('#mobile-navigation-wrapper').toggleClass('active');
    $(this).toggleClass('active');
  });
  const plus = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.07104 0V14.1421M-2.2769e-05 7.07107H14.1421" stroke="white" stroke-width="2" stroke-miterlimit="10"/></svg>';
  const minus = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="2" viewBox="0 0 15 2" fill="none"><path d="M-2.2769e-05 0.999992H14.1421" stroke="white" stroke-width="2" stroke-miterlimit="10"/></svg>';

  $('#mobile-navigation .menu-item-has-children').append('<span class="menu-toggle">' + plus + '</span>');

  $('#mobile-navigation').on('click', '.menu-toggle', function(e) {
    e.stopPropagation();
    const $parent = $(this).closest('.menu-item-has-children');
    $parent.toggleClass('open');
    $(this).html($parent.hasClass('open') ? minus : plus);
  });

  var scroll_actions = function() {
    $('.loading').each(function(){
      $(this).addClass('loaded');
    });
    for (var i = 0; i <= 21; i++) {
      var selector = i === 0 ? '.animate' : '.animate-' + i;
      var delay = i * 100;
      $(selector).each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){ $this.addClass('visible'); }, delay);
        }
      });
    }
  };

  $(window).on('load', function(){
    $(window).trigger('resize');
    setTimeout(function(){ $(window).trigger('resize'); }, 500);
    scroll_actions();
  });
  $(document).ready(scroll_actions);
  $(window).on('scroll', scroll_actions);

});